module.exports = __webpack_public_path__ + "static/img/playheraLogo.a854ea67.png";